import { Component, Inject, OnInit } from '@angular/core';
import { MessageFromFoxpost } from '../message-from-foxpost';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DeliveryData } from '../typeofdelivery/delivery';
import { ShoppingcartService } from '../shoppingcart.service';
import { Router } from '@angular/router';
import { DeliveryOption } from '../typeofdelivery/deliveryoptions';

@Component({
    selector: 'lib-foxpostpopup',
    templateUrl: './foxpostpopup.component.html',
    styleUrls: ['./foxpostpopup.component.css']
})
export class FoxpostpopupComponent implements OnInit {
    foxpostObject?: MessageFromFoxpost = {};

    totalAmount = 0;

    selectedAlign: 'start' | 'center' | 'end';

    data: DeliveryData = {};

    errorMessageFoxpost = '';

    constructor(@Inject(MAT_DIALOG_DATA) public deliveryOptionElement:DeliveryOption,private _router: Router, private _shoppingCartService: ShoppingcartService, private _dialog: MatDialog) {
        this.selectedAlign = 'end';
    }

    ngOnInit(): void {
        window.addEventListener(
            'message',
            (event) => {
                this.foxpostObject = this.receiveMessage(event);
                if (this.foxpostObject.zip != null) {
                    this.setFoxpostData();
                } else {
                    this.errorMessageFoxpost = 'Válassza ki a megfelelő csomagpontot a Kiválasztom gombra kattintva!';
                }
            },
            false
        );
    }
    receiveMessage(event: MessageEvent): MessageFromFoxpost {
        let apt: MessageFromFoxpost = {};
        if (event.origin !== 'https://cdn.foxpost.hu') {
            return new MessageFromFoxpost();
        } else if (event.data) {
            apt = JSON.parse(event.data) as MessageFromFoxpost;
        }

        return apt;
    }

    closeDialog() {
        this._dialog.closeAll();
    }

    setFoxpostData() {
        this.data = {
            deliveryOption: this.deliveryOptionElement.name,
            deliveryZipCode: Number(this.foxpostObject?.zip),
            deliverySettlement: this.foxpostObject?.city,
            deliveryAddress: this.foxpostObject?.address + ' ' + this.foxpostObject?.findme,
            deliveryFee: this.deliveryOptionElement.deliveryFee,
            handlingFee:this.deliveryOptionElement.handlingFee
        };
        if (this._shoppingCartService.order) {
            this._shoppingCartService.order.deliveryData = this.data;
            if (this._shoppingCartService.order.deliveryData?.deliveryFee && this._shoppingCartService.order.totalPriceOfBooks) {
                this.totalAmount =
                    this.deliveryOptionElement.deliveryFee!+this.deliveryOptionElement.handlingFee! + this._shoppingCartService.order.totalPriceOfBooks;
                this._shoppingCartService.order.totalPrice = this.totalAmount;
            }

            sessionStorage.setItem('deliveryData', JSON.stringify(this.data));


        }
        this.closeDialog();
    }
}
